import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const userLanguage = window.navigator.language.split('-')[0] || 'en';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: process.env.REACT_APP_SERVER_BASE_URL === 'stg' ? true : false,
    lng: userLanguage,
    fallbackLng: 'en',
    ns: ['util', 'main', 'utils'],
  });

export default i18n;
